import React, {useRef} from 'react';
import Container from "../../Wrappers/Container";
import UserAvatar from "../../Atoms/Templates/UserAvatar";
import TextIcon from "../../Atoms/TextIcon";
import Badge from "../../Atoms/Badge";
import {getUserType} from "../../../helpers/get-user-type";
import LeaveCompanyModal from "../Modals/LeaveCompanyModal";
import CantLeaveCompanyModal from "../Modals/CantLeaveCompanyModal";

const ProfileHeader = () => {
  const userType = getUserType('OWNER')

  const cantLeaveCompanyModal = useRef()

  const handleOpenCantLeaveCompanyModal = () => {
    cantLeaveCompanyModal.current.openModal()
  }

  return (
    <>
      <Container className="s-main-justify s-cross-center s-flex-gap-24px">
        <div className="flex nowrap">
          <UserAvatar size="bigger"
            className="s-mr-16px"/>
          <div>
            <h1 className="t2 s-mb-4px">Evelyn Castrejón Jiménez</h1>
            <div className="s-cross-center">
              <TextIcon className="s-cross-center s-mr-16px"
                icon="mail"
                text="evelyn-cas@discord.com"/>
              <Badge text={userType.rol}
                color={userType.color}/>
            </div>
          </div>
        </div>
        <button className="button delete" onClick={handleOpenCantLeaveCompanyModal}>Abandona esta empresa</button>
      </Container>
      {/* Modal para cuando el usuario quiere abandonar la empresa */}
      <LeaveCompanyModal/>

      {/* Modal para cuando el usario no puede abandonar la empresa */}
      <CantLeaveCompanyModal ref={cantLeaveCompanyModal}/>
    </>
  );
};

export default ProfileHeader;
